import { render, staticRenderFns } from "./BtnMyTeam.vue?vue&type=template&id=71e52b14&scoped=true"
import script from "./btnMyTeam.ts?vue&type=script&lang=ts&external"
export * from "./btnMyTeam.ts?vue&type=script&lang=ts&external"
import style0 from "./BtnMyTeam.vue?vue&type=style&index=0&id=71e52b14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e52b14",
  null
  
)

export default component.exports